import { render, staticRenderFns } from "./CustomerBill.vue?vue&type=template&id=2403dca1"
import script from "./CustomerBill.vue?vue&type=script&lang=js"
export * from "./CustomerBill.vue?vue&type=script&lang=js"
import style0 from "./CustomerBill.vue?vue&type=style&index=0&id=2403dca1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports